import Icon from "@components/Icon";
import { colours, device } from "@helpers";
import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: ${({ showModal }) => (showModal ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 85px 69px 59px;
  border-top-left-radius: 60px;
  background-color: ${colours.PALE_PEACH};

  @media (max-width: ${device.tablet}) {
    border-top-left-radius: 32px;
    padding: 68px 39px 54px;
  }

  @media (min-width: ${device.tablet}) and (max-width: ${device.laptop}) {
    padding: 81px 64px 58px;
  }

  @media (min-width: ${device.laptop}) and (max-width: ${device.desptop}) {
    border-top-left-radius: 80px;
    padding: 103px 95px 45px;
  }

  @media (min-width: ${device.desktop}) {
    padding: 103px 415px 102px;
    border-top-left-radius: 80px;
  }
`;

const ButtonContainer = styled.div`
  align-self: flex-end;
  font-size: 18px;
  object-fit: contain;

  :hover {
    cursor: pointer;
  }

  @media (max-width: ${device.tablet}) {
    font-size: 11px !important;
  }

  @media (min-width: ${device.tablet}) and (max-width: ${device.laptop}) {
    font-size: 27px !important;
  }

  @media (min-width: ${device.laptop}) and (max-width: ${device.desktopS}) {
    font-size: 22px !important;
  }

  @media (min-width: ${device.desktop}) {
    font-size: 22px !important;
  }
`;

const Body = styled.p`
  margin-top: 30px;
`;

const Modal = ({ showModal, closeModal, heading, body }) => (
	<Container className="full-size-modal" showModal={showModal}>
		<Content>
			<ButtonContainer onClick={closeModal}>
				<Icon iconName="close" alt="close" />
			</ButtonContainer>
			<p>{heading}</p>
			<Body>{body}</Body>
		</Content>
	</Container>
);

export default Modal;
